import {
  IConfigKiosk,
  IConfigKioskColors,
  IConfigKioskColorsValidation,
  IConfigKioskConfiguration,
  IConfigKioskConfigurationValidation,
  IConfigKioskImages,
  IConfigKioskImagesValidation,
} from '../types';
import { defaultTTranslate, defaultValidation } from 'src/constants/main';
import { Theme } from '~/constants/styles';

export enum KioskTimerStart {
  TEN = '10',
  FIFTEEN = '15',
  TWENTY = '20',
}

export const defaultConfigKioskColors: IConfigKioskColors = {
  theme: Theme.LIGHT,
  mainColor: '#ffffff',
};

export const defaultConfigKioskImages: IConfigKioskImages = {
  bannerImage: '',
};

export const defaultConfigKioskConfiguration: IConfigKioskConfiguration = {
  timeStart: KioskTimerStart.TEN,
  smsConfirmation: 1,
  message: defaultTTranslate,
  accessCode: '1234',
};

export const defaultConfigKiosk: IConfigKiosk = {
  colors: defaultConfigKioskColors,
  images: defaultConfigKioskImages,
  configuration: defaultConfigKioskConfiguration,
};

export const defaultConfigKioskColorsValidation: IConfigKioskColorsValidation = {
  isValid: true,
  mainColor: defaultValidation,
};

export const defaultConfigKioskImagesValidation: IConfigKioskImagesValidation = {
  isValid: true,
  bannerImage: defaultValidation,
};

export const defaultConfigKioskConfigurationValidation: IConfigKioskConfigurationValidation = {
  isValid: true,
  accessCode: defaultValidation,
};
